var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('RelationsTable',{attrs:{"relations":_vm.relations,"addAgencyCol":false,"showExelExport":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }